import * as Cookies from 'js-cookie'

// need to find out how long this cache lasts
export const writeToCache = async (key, value) => {
  if (!window.caches) {
    return
  }
  const cache = await caches.open('mv')
  const headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Accept', 'application/json')
  headers.append('Cache-Control', 'max-age=31557600')
  cache.put(
    key,
    new Response(JSON.stringify(value), {
      headers
    })
  )
}
export const readFromCache = async (key) => {
  if (!window.caches) {
    return null
  }
  const cache = await window.caches.open('mv')
  if (!cache) {
    return null
  }
  const response = await cache.match(key)
  if (!response) {
    return null
  }
  if (!response.ok) {
    return null
  }

  return await response.json()
}

export const writeToAll = async (key, value) => {
  await writeToCache(key, value)

  Cookies.set(key, value, {
    path: '/',
    expires: 365
  })

  return true
}

export const readFromAll = async (key) => {
  // tslint:disable-next-line:no-any
  const allResults: any = {}
  allResults.cache = await readFromCache(key)
  allResults.cookie = Cookies.getJSON(key)

  return allResults
}

export const readAndResolve = async (key) => {
  const allData = await readFromAll(key)
  if (allData.cookie && !allData.cache) {
    writeToCache('/mv_tokens', allData.cookie)

    return allData.cookie
  }
  if (allData.cache && !allData.cookie) {
    Cookies.set('mv_tokens', allData.cache)

    return allData.cache
  }
  if (allData.cache && allData.cookie) {
    return allData.cookie
  }

  return null
}
